import { Invoice } from "@/interfaces/invoice";
import { sendFetchRequest } from "@/utils/sendFetchRequest";

type getDocumentFileProps = {
  invoice: Invoice;
};

export const getDocumentFile = ({ invoice }: getDocumentFileProps) => {
  const token = sessionStorage.getItem("keycloak_token") ?? "";

  return new Promise<Blob>((resolve, reject) => {
    sendFetchRequest(
      `/invoices/v1/getDocumentFile?schemaId=${invoice.franchiseId}&invoiceId=${invoice.id}&isPriceWithTaxes=false&filename=${invoice.id}`,
      token
    )
      .then((response: Blob) => {
        resolve(response);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const getCustomerDocumentFile = ({ invoice }: getDocumentFileProps) => {
  const token = sessionStorage.getItem("keycloak_token") ?? "";

  return new Promise<Blob>((resolve, reject) => {
    sendFetchRequest(
      `/customers/v1/getDocumentFile?schemaId=${invoice.franchiseId}&invoiceId=${invoice.id}&isPriceWithTaxes=false&filename=${invoice.id}`,
      token
    )
      .then((response: Blob) => {
        resolve(response);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
